'use client'
import { type FC, useCallback, useEffect, useRef } from 'react'
import { Box, VStack } from '@chakra-ui/react'
import type { KlarnaOrder, Option } from 'ecosystem'
import { useRefUpdated } from 'ui/hooks/useRefUpdated'
import { subscribeToKlarnaCheckoutEvents } from './utils'

export interface IKlarnaCheckoutProps {
  klarnaData?: Option<KlarnaOrder>
  onReady?: () => void
  onCheckout?: () => void
  onPurchase?: () => void
}

export const KlarnaCheckout: FC<IKlarnaCheckoutProps> = ({ klarnaData, onReady }) => {
  const isCheckoutCreated = useRef(false)

  const handleIsReadyRef = useRefUpdated(onReady)

  const handleIsReady = useCallback(() => {
    if (!klarnaData || isCheckoutCreated.current) {
      return
    }

    handleIsReadyRef.current?.()
    isCheckoutCreated.current = true
  }, [handleIsReadyRef, klarnaData])

  useEffect(() => {
    const checkoutContainer = document.getElementById('my-checkout-container')
    if (checkoutContainer) {
      checkoutContainer.innerHTML = (document.getElementById('KCO') as any)?.value
        .replace(/\\"/g, '"')
        .replace(/\\n/g, '')
      const scriptsTags = checkoutContainer.getElementsByTagName('script')

      // eslint-disable-next-line @typescript-eslint/prefer-for-of -- refactor to avoid warning
      for (let i = 0; i < scriptsTags.length; i++) {
        const parentNode = scriptsTags[i].parentNode
        const newScriptTag = document.createElement('script')
        newScriptTag.type = 'text/javascript'
        newScriptTag.text = scriptsTags[i].text
        parentNode?.removeChild(scriptsTags[i])
        parentNode?.appendChild(newScriptTag)
      }
    }
  }, [])

  useEffect(() => {
    let timerId: number

    const pollForKlarnaCheckout = () => {
      if (window._klarnaCheckout) {
        subscribeToKlarnaCheckoutEvents({
          load: () => {
            handleIsReady?.()
          }
        })
      } else {
        // Poll every 100ms until it's available
        timerId = window.setTimeout(pollForKlarnaCheckout, 100)
      }
    }

    pollForKlarnaCheckout()

    return () => {
      window.clearTimeout(timerId)
    }
  }, [handleIsReady])

  if (!klarnaData) {
    return null
  }

  return (
    <VStack align="flex-start" minW="320px" w="full">
      <Box as="div" w="full">
        <textarea id="KCO" readOnly style={{ display: 'none' }} value={klarnaData.html_snippet} />

        <div id="my-checkout-container" />
      </Box>
    </VStack>
  )
}
